import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f997be42"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户列表", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "crumbs"
  }, {
    default: _withCtx(() => [_createVNode(_component_svg_icon, {
      "icon-class": "house"
    }), _hoisted_2]),
    _: 1
  }), _createVNode(_component_BatterTableDataView, {
    "table-id": 18,
    initQuery: $data.initQuery,
    onOnResetQuery: _cache[0] || (_cache[0] = $event => $data.initQuery = {}),
    onOnFetchData: $options.onFetchData
  }, {
    enable: _withCtx(data => [_createVNode(_component_el_switch, {
      "active-color": "#0078D7",
      "model-value": $data.enableMap[data.rowId],
      onChange: v => $options.enableChange(data.rowId, v)
    }, null, 8, ["model-value", "onChange"])]),
    enableManagerLogin: _withCtx(data => [_createVNode(_component_el_switch, {
      "active-color": "#0078D7",
      "model-value": $data.loginMap[data.rowId],
      onChange: v => $options.enableManagerLoginChange(data.rowId, v)
    }, null, 8, ["model-value", "onChange"])]),
    _: 1
  }, 8, ["initQuery", "onOnFetchData"])]);
}